import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import legalAssociationsRightsSuppressionGroupItemValidator from './validators/item';
import { LegalAssociationsRightsSuppressionGroupModel } from './types';

const legalAssociationsRightsSuppressionGroupValidator: ValidateJSModel<LegalAssociationsRightsSuppressionGroupModel> = {
  HasRightsSuppressionGroup: { presence: true, hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasRightsSuppressionGroup?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalAssociationsRightsSuppressionGroupItemValidator },
      };
    }
    return {};
  },
};

export default legalAssociationsRightsSuppressionGroupValidator;
